import {
 Box,
 Checkbox,
 CircularProgress,
 FormControlLabel,
 FormGroup,
} from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InfoList from './InfoList';
import { GroupDTO, UsersDTO } from '@redux/identity/identityTypes';
import GenerateAPIKey from '@/components/adminUsers/GenerateAPIKey';
import XTabs from '../XTabs';
import {
 identityGetItemGroupsStart,
 identityUpdateSelfStart,
} from '@redux/identity/identitySlice';
import { RootState } from '@redux/store';

const fields = [
 'Name',
 'Surname',
 'Email',
 'Phone',
 'AuthEmail',
 'AuthPhone',
 'RequestToChangePasswordAfterDays',
];

const IdentitySidebar = ({ item }: { item: UsersDTO }) => {
 const dispatch = useDispatch();
 const { groups, loading } = useSelector((state: RootState) => state.identity);

 const userGroupIds = item?.Groups?.map((g: GroupDTO) => g.Id) || [];

 useEffect(() => {
  dispatch(identityGetItemGroupsStart({}));
 }, [dispatch]);

 const handleGroupToggle = (groupId: number, isChecked: boolean) => {
  let updatedGroupIds: number[];
  if (isChecked) {
   updatedGroupIds = [...userGroupIds, groupId];
  } else {
   updatedGroupIds = userGroupIds.filter((id) => id !== groupId);
  }
  dispatch(identityUpdateSelfStart({ Groups: updatedGroupIds }));
 };

 const generalTab = (
  <Box>
   <InfoList data={item} customFields={fields} />
   <GenerateAPIKey userId={item?.Id || ''} />
  </Box>
 );

 const additionalTab = (
  <Box sx={{ p: 0 }}>
   {loading?.identityGetItemGroups && (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
     <CircularProgress size={24} />
    </Box>
   )}
   {!loading?.identityGetItemGroups && (
    <FormGroup>
     {groups?.map((group: GroupDTO) => (
      <FormControlLabel
       key={group.Id}
       control={
        <Checkbox
         checked={userGroupIds.includes(group.Id)}
         onChange={(e) => handleGroupToggle(group.Id, e.target.checked)}
         disabled={!!loading?.identityUpdateSelf}
        />
       }
       label={group.Name || `Group ${group.Id}`}
      />
     ))}
    </FormGroup>
   )}
  </Box>
 );

 const tabs = [
  { id: 'general', label: 'General', content: generalTab },
  { id: 'additional', label: 'Additional', content: additionalTab },
 ];

 return (
  <Box sx={{ p: 0 }}>
   <XTabs tabs={tabs} ariaLabel="Identity sidebar tabs" />
  </Box>
 );
};

export default IdentitySidebar;

